import { Inject, Injectable } from '@angular/core'
import { Nl2brPipe } from '../../shared/pipes/nl2br.pipe'
import { DialogService } from './dialog.service'
import { firstValueFrom } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class ErrorService {

    constructor(@Inject(DialogService) private dialogService: DialogService,
                @Inject(Nl2brPipe) private nl2brPipe: Nl2brPipe,) {
    }

    /**
     * Handles error response and alerts user.
     * @param error
     * @param additionalMessage
     */
    onErrorResponseAlertUser(error, additionalMessage?: string): Promise<any> {
        if (error?.status === 400) {
            const message = this.build400Message(error, additionalMessage)
            const validationErrors = this.build400ValidationErrors(error)

            const content = validationErrors?.length ? [message].concat(validationErrors) : [message]
            return firstValueFrom(this.dialogService.showSimpleDialog('Upozornění', content, 'Rozumím'))
        }

        return Promise.resolve()
    }

    resolveServerError(response): boolean {
        if (response.status === 500
            && response.data
            && response.data instanceof Blob
        ) {
            const reader = new FileReader()

            reader.onload = (() => {
                return (e): void => {
                    // @ts-ignore
                    const jsonObj = JSON.parse(e.target.result)

                    if (jsonObj && (jsonObj.id || jsonObj.errorId)) {
                        this.showErrorDialog(jsonObj.id || jsonObj.errorId)
                    } else {
                        this.showErrorDialog()
                    }
                }
            })()

            // Read in the image file as a data URL.
            reader.readAsText(response.data)
            return true
        } else if (response.status === 500
            && response.data
            && (response.data.id || response.data.errorId)
        ) {
            this.showErrorDialog(response.data.id || response.data.errorId)
            return true
        } else if (response.status === 500 // using angular http
            && response.error
            && response.error.errorId
        ) {
            this.showErrorDialog(response.error.errorId)
            return true
        } else if (response.status === 500) {
            this.showErrorDialog()
            return true
        }

        return true
    }

    getErrorObjectFromBlob(blob): Promise<any> {
        return new Promise<any>((resolve) => {
            const reader = new FileReader()

            reader.onload = (function () {
                return (e): void  => {
                    // @ts-ignore
                    let jsonObj = JSON.parse(e.target.result)
                    if (jsonObj.status === 400) {
                        jsonObj.data = jsonObj
                        resolve(jsonObj)
                    } else {
                        resolve('Vyskytla se neočekávaná chyba.')
                    }
                }
            })()

            reader.readAsText(blob)
        })
    }

    /************************************************************************/

    private showErrorDialog(id?: string): Promise<boolean> {
        let message = `<p>Je nám líto, ale v aplikaci došlo k neočekávané chybě.</p>
                   <p>Kontaktuje prosím HelpDesk a popište co nejlépe situaci, při které se vám povedlo chybu vyvolat.`
        message += (id && typeof id === 'string') ? ` Během komunikace s HelpDeskem uvádějte identifikátor chyby:</p><p>${id}</p>` : '</p>'

        return firstValueFrom(this.dialogService.showSimpleDialog('Vyskytla se neočekávaná chyba', [message], 'Rozumím'))
    }

    private build400Message(error, additionalMessage): string {
        const errorMessage = error?.data?.message || error?.error?.message
        let message = `<p>${this.nl2brPipe.transform(errorMessage)}</p>`

        return additionalMessage ? message + `<p>${additionalMessage}</p>` : message
    }

    private build400ValidationErrors(error): string[] {
        const errorMessage = (error?.data?.message) ? [error?.error?.message] : []
        const validationErrors = error?.data?.validationErrors
                              || error?.error?.validationErrors
                              || error?.data?.message
                              || error?.error?.message
                              || errorMessage
        let errorsString = []

        for (let error of validationErrors) {
            errorsString.push(error.validationMessage)
        }
        return errorsString
    }
}
